export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "rejection_classification": {
          "excellent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excelente"])},
          "good": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bueno"])},
          "acceptable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aceptable"])},
          "caution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precaución"])},
          "critical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crítico"])},
          "range_excellent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["0% - 1%"])},
          "range_good": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1% - 2%"])},
          "range_acceptable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2% - 3%"])},
          "range_caution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["3% - 5%"])},
          "range_critical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["> 5%"])}
        }
      },
      "en": {
        "rejection_classification": {
          "excellent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excellent"])},
          "good": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Good"])},
          "acceptable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acceptable"])},
          "caution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Caution"])},
          "critical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Critical"])},
          "range_excellent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["0% - 1%"])},
          "range_good": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1% - 2%"])},
          "range_acceptable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2% - 3%"])},
          "range_caution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["3% - 5%"])},
          "range_critical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["> 5%"])}
        }
      }
    }
  })
}